module.exports = __webpack_public_path__ + "static/media/image_placeholder.c910111f.jpg";